import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
  HttpStatusCode
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { inject, Injector } from '@angular/core';
import { GlobalMessageHandlerService } from '../services/util/global-message-handler.service';
import { TranslateService } from '@ngx-translate/core';

export const cafBootHttpErrorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const globalErrorHandler = inject(GlobalMessageHandlerService);
  const injector = inject(Injector);
  globalErrorHandler.emitError(null);
  return next(request).pipe(
    catchError((error) => handleError(error, globalErrorHandler,injector))
  );
};

const handleError = (
  error: any,
  globalErrorHandler: GlobalMessageHandlerService, injector: Injector
): Observable<never> => {
  let errorMessage: string;
  const translationService = injector.get(TranslateService); 
  if (error instanceof HttpErrorResponse) {
    console.error('Error HTTP:', error);

    switch (error.status) {
      case HttpStatusCode.BadRequest:
        errorMessage = parseErrorResponse(error.error) || translationService.instant('ERROR.ERROR_400');
        break;
      case HttpStatusCode.Unauthorized:
        errorMessage = parseErrorResponse(error.error) || translationService.instant('ERROR.ERROR_401');
        break;
      case HttpStatusCode.Forbidden:
        errorMessage = translationService.instant('ERROR.ERROR_403');
        break;
      case HttpStatusCode.NotFound:
        errorMessage = translationService.instant('ERROR.ERROR_404');
        break;
      case HttpStatusCode.InternalServerError:
        errorMessage = translationService.instant('ERROR.ERROR_500');
        break;
      case HttpStatusCode.BadGateway:
        errorMessage = translationService.instant('ERROR.ERROR_502');
        break;
      case HttpStatusCode.ServiceUnavailable:
        errorMessage = translationService.instant('ERROR.ERROR_503')
        break;
      case 0:
        errorMessage = translationService.instant('ERROR.ERROR_0');
        break;
      default:
        errorMessage = translationService.instant('ERROR.ERROR_DESCONOCIDO');
    }

    globalErrorHandler.emitError(errorMessage);
  }
  return throwError(() => error);
};

const parseErrorResponse = (error: any): string | null => {
  if (error?._message) {
    if (error._message.description) {
      const details = error._message.details;
      if (Array.isArray(details) && details.length > 0) {
        const detailMessages = details.map((detail: any) => {
          const field = detail.fieldName ? `Field: ${detail.fieldName}` : '';
          const description = detail.description || '';
          return `${field} - ${description}`.trim();
        }).join('; ');
        return error._message.description + ": " + detailMessages;
      }
      return error._message.description;
    }
  } else if (error?.message) {
    return error.message;
  } else if (typeof error === 'string') {
    return error;
  }
  return null;
};

